import { render, staticRenderFns } from "./CvWarnBand.vue?vue&type=template&id=a76156f2&scoped=true"
import script from "./CvWarnBand.vue?vue&type=script&lang=js"
export * from "./CvWarnBand.vue?vue&type=script&lang=js"
import style0 from "./CvWarnBand.vue?vue&type=style&index=0&id=a76156f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a76156f2",
  null
  
)

export default component.exports